import mobileLogo from '../../../assets/Name - White Transparent.svg'
import styled, { css } from 'styled-components/macro'
import MobileSlideOutMenu from './MobileSlideOutMenu'
import { PiList } from 'react-icons/pi'
import { useClickOutside } from 'hooks/useClickOutside'
import { useState } from 'react'
import { NotificationButton } from 'components/Notification/NotificationButton'
import * as S from './styles'

const HamburgerMenu = css`
  cursor: pointer;
  color: white;
  font-size: 26px;
  height: 50px;
  width: 50px;
  padding: 10px;
`

export const HamburgerMenuIcon = styled(PiList)`
  ${HamburgerMenu}
`

export function MobileAuthenticatedNav() {
  const [isSlideOutOpen, setIsSlideOutOpen] = useState(false)

  const handleOpenSlideOut = () => {
    setIsSlideOutOpen(false)
  }

  const ref = useClickOutside<HTMLDivElement>(handleOpenSlideOut)

  return (
    <S.MobileWrapper ref={ref}>
      <S.MobileNavContent>
        <S.MobileNavLeft>
          <HamburgerMenuIcon onClick={() => setIsSlideOutOpen(true)} />
          <S.LogoImg width="81px" src={mobileLogo} alt="First Bite" />
        </S.MobileNavLeft>
        <div className="mr-4">
          <NotificationButton />
        </div>
      </S.MobileNavContent>
      {isSlideOutOpen && (
        <MobileSlideOutMenu
          isOpen={isSlideOutOpen}
          onClose={() => setIsSlideOutOpen(false)}
        />
      )}
    </S.MobileWrapper>
  )
}
